/// <amd-module name="TFS/DRITools/Components/Common/Error" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";

export interface IErrorProps {
    error: string;
}

export class ErrorMessage extends VssComponent<IErrorProps, {}> {
    public render(): JSX.Element {
        const { error } = this.props;

        return <div className="dri-tools-common error">{error.toString()}</div>;
    }
}

export default ErrorMessage;
